export default "__VITE_ASSET__DynJprdn__"